<template>
  <v-container fluid>
    <!-- Search bar -->
    <v-row align="center">
      <v-col cols="6" class="text-left mb-2">
        <v-text-field v-model="search" label="Recherchez une entreprise" single-line hide-details></v-text-field>
      </v-col>
      <v-col cols="6" class="text-right">
        <!-- Button to open add notice dialog -->
        <v-btn small color="primary" dark @click="openDialog">
          <v-icon small class="mr-2">mdi-plus</v-icon>AJOUTER UNE ENTREPRISE
        </v-btn>
      </v-col>
    </v-row>

    <!-- Dialog for adding new notice -->
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <h4 class="headline">{{ formTitle }}</h4>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="exclusion.nomCabinet" label="Nom du cabinet / Raison sociale"></v-text-field>
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="exclusion.rccm" label="N° RCCM"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="exclusion.nif" label="N° NIF"></v-text-field>
            </v-col>
          </v-row>
          <v-text-field v-model="exclusion.sigle" label="Sigle"></v-text-field>
          <v-text-field v-model="exclusion.referenceDecision" label="Référence de la décision"></v-text-field>
          <v-textarea v-model="exclusion.motifExclusion" label="Motif de l’exclusion"></v-textarea>
          <v-row>
            <v-col cols="6">
              <label>Date début sanction</label>
              <date-picker v-model="exclusion.dateDebutSanction" value-type="format" format="YYYY-MM-DD"
                :default-value="new Date()" placeholder="Indiquer la date de début de la sanction"
                type="date"></date-picker>
            </v-col>
            <v-col cols="6">
              <label>Date fin sanction</label>
              <date-picker v-model="exclusion.dateFinSanction" value-type="format" format="YYYY-MM-DD"
                :default-value="new Date()" placeholder="Indiquer la date de fin de la sanction"
                type="date"></date-picker>
            </v-col>

          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" text @click="closeDialog">
            ANNULER L'OPÉRATION
          </v-btn>
          <v-btn small color="green darken-1" text @click="addExclusion">
            AJOUTER L'ENTREPRISE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Button to open add notice dialog -->
    <!-- <v-btn small color="primary" dark class="mb-2" @click="openDialog">
        <v-icon small class="mr-2">mdi-plus</v-icon>AJOUTER UNE ENTREPRISE
      </v-btn> -->

    <!-- Data table for displaying exclusions -->
    <!-- Data table for displaying exclusions -->
    <v-data-table locale="fr" :headers="headers" :search="search" no-data-text="Aucune entreprise trouvée"
      :items="this.$store.getters['Auth/getExclusion']"  @click:row="goto" class="elevation-1 mb-5 px-5">
      <!-- Slot for custom row rendering -->
      <template v-slot:[`item.dateDebutSanction`]="{ item }">{{
          item.dateDebutSanction | moment("DD MMMM YYYY")
        }}</template>

        <template v-slot:[`item.dateFinSanction`]="{ item }">{{
          item.dateFinSanction | moment("DD MMMM YYYY")
        }}</template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: { DatePicker },
  data: () => ({
    search: "",
    dialog: false,
    formTitle: "Ajouter une entreprise",
    exclusion: {
      nomCabinet: "",
      rccm: "",
      nif: "",
      sigle: "",
      referenceDecision: "",
      motifExclusion: "",
      dateDebutSanction: null,
      dateFinSanction: null,
    },

    headers: [
      { text: "Nom du cabinet", align: "start", sortable: false, value: "nomCabinet" },
      { text: "Reference de la décision", sortable: false, value: "referenceDecision" },
      { text: "Motif de l’exclusion", sortable: false, value: "motifExclusion" },
      { text: "Date de début de sanction", sortable: false, value: "dateDebutSanction" },
      { text: "Date de fin de sanction", sortable: false, value: "dateFinSanction" },
    ],
  }),
  created() {
    this.$store.dispatch("Auth/loadAllExclusions");
    this.$store.dispatch("Auth/getData");
  },
  methods: {
    ...mapActions({
      loadAllExclusions: "Auth/loadAllExclusions",
      sendExclusion: "Auth/addExclusion"
    }),
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    goto(value) {
      const { id } = value;
      this.$router.push({ name: "RegshowExclusion", params: { id: id } });
    },
    addExclusion() {
      const data = new FormData();
      data.append("nomCabinet", this.exclusion.nomCabinet);
      data.append("rccm", this.exclusion.rccm);
      data.append("nif", this.exclusion.nif);
      data.append("sigle", this.exclusion.sigle);
      data.append("referenceDecision", this.exclusion.referenceDecision);
      data.append("motifExclusion", this.exclusion.motifExclusion);
      data.append("dateDebutSanction", this.exclusion.dateDebutSanction);
      data.append("dateFinSanction", this.exclusion.dateFinSanction);

      this.sendExclusion(data);

      this.exclusion.nomCabinet = "";
      this.exclusion.rccm = "";
      this.exclusion.nif = "";
      this.exclusion.sigle = "";
      this.exclusion.referenceDecision = "";
      this.exclusion.motifExclusion = "";
      this.exclusion.dateDebutSanction = null;
      this.exclusion.dateFinSanction = null;
    },

  }
};
</script>

<style>
.vue-daterange-picker {
  width: 100% !important;
}

.mx-datepicker {
  width: 100% !important;
}

.w-62em {
  height: 62em !important;
  width: 100% !important;
}

.date-picker-wrapper {
  margin-bottom: 16px;
}

.date-picker-wrapper label {
  font-weight: bold;
}
</style>